import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import { formatMoney } from "../../../../helpers/formatter";
import React, { useEffect, useState } from "react";
import {
  ProviderList,
  ProvidersResponse,
} from "../../../../custom-hooks/useFetchOutwardTransferProviders";
import styles from "../../TransactionSetting.module.scss";
import EditProviderInfo from "../modals/EditProviderInfo";

interface IProviderProps {
  transferProviders: ProvidersResponse;
}

const Provider = ({ transferProviders }: IProviderProps) => {
  const [openEditLimitModal, setOpenEditLimitModal] = useState(false);
  const [selectedProviderDetails, setSelectedProviderDetails] =
    useState<ProviderList | null>(null);
  const [selectedBankCode, setSelectedBankCode] = useState<string | null>(null);

  useEffect(() => {
    if (!selectedProviderDetails?.id) return;
    setSelectedBankCode(selectedProviderDetails?.accounts?.[0]?.bankCode || "");
  }, [selectedProviderDetails?.id, selectedProviderDetails?.accounts]);

  const handleSelectProvider = (provider: ProviderList) => {
    setSelectedProviderDetails(provider);
    setOpenEditLimitModal(true);
  };

  const onCancellimitModal = () => {
    setOpenEditLimitModal(false);
    setSelectedProviderDetails(null);
    setSelectedBankCode(null);
  };

  return (
    <div className="w-full mt-40">
      <MDBTable
        responsive
        minimal="true"
        striped
        bordered
        hover
        id="table-to-xls"
      >
        <MDBTableHead>
          <tr>
            <th>Provider</th>
            <th>Maximum Transaction Amount</th>
            <th>Threshold Amount</th>
            <th>Active Account</th>
            <th>Action</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {transferProviders?.data?.providers?.map((provider) => {
            const activeAccount = provider.accounts?.find(
              (account) => account.isSetProviderAccount,
            );

            return (
              <tr key={provider.id}>
                <td>{provider.name}</td>
                <td>{formatMoney(provider.maximumTransferAmount)}</td>
                <td>{formatMoney(provider.thresholdAmount)}</td>
                <td>
                  {provider.accounts && provider.accounts.length > 0 ? (
                    activeAccount ? (
                      <>
                        <div>
                          <strong>{activeAccount.bankName}</strong> {"-"}{" "}
                          {activeAccount.accountNumber} {"-"}{" "}
                          {activeAccount.accountName}
                        </div>
                      </>
                    ) : (
                      <span>N/A</span>
                    )
                  ) : (
                    <span>N/A</span>
                  )}
                </td>
                <td>
                  <button
                    className={`${styles.edit_btn} ${!provider.accounts || provider.accounts.length === 0 ? styles.disable_edit_btn : ""}`}
                    onClick={() => handleSelectProvider(provider)}
                  >
                    Edit
                  </button>
                </td>
              </tr>
            );
          })}
        </MDBTableBody>
      </MDBTable>

      <EditProviderInfo
        open={openEditLimitModal}
        handleCancel={onCancellimitModal}
        title="Edit Provider Details"
        confirmBtnText="Update"
        cancelBtnTxt="Cancel"
        _selectedBankCode={selectedBankCode}
        selectedProviderDetails={selectedProviderDetails}
      />
    </div>
  );
};

export default Provider;
